export default {
    isAgency: function() {
        let user = this.$store.state.user

        if (user) {
            let userRole = user.roles[0],
                agency = user.agency

            return userRole === 'ROLE_AGENCY' && agency
        }

        return false
    },

    isSellingAgency: function() {
        let user = this.$store.state.user
        if (user) {
            let agency = user.agency

            return agency && agency.cart
        }

        return false
    }
}
